import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initaialState = {
  profileDetails: null,
  loading: true
};

const getProfileDetailsStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const getProfileDetailsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    profileDetails: action.details
  });
};

const getProfileDetailsFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};

const putProfileDetailsStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const putProfileDetailsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};

const putProfileDetailsFail = (state, action) => {
  return updateObject(state, {
    loading: false
  });
};

const setNewProfileObj = (state, action) => {
  let newObj = { ...state.profileDetails };
  newObj[action.name] = action.value;
  return {
    ...state,
    profileDetails: newObj
  };
};

const reducer = (state = initaialState, action) => {
  switch (action.type) {
    case actionTypes.PROFILE_GET_DETAILS_START:
      return getProfileDetailsStart(state, action);
    case actionTypes.PROFILE_GET_DETAILS_SUCCESS:
      return getProfileDetailsSuccess(state, action);
    case actionTypes.PROFILE_GET_DETAILS_FAIL:
      return getProfileDetailsFail(state, action);
    case actionTypes.PROFILE_PUT_DETAILS_START:
      return putProfileDetailsStart(state, action);
    case actionTypes.PROFILE_PUT_DETAILS_SUCCESS:
      return putProfileDetailsSuccess(state, action);
    case actionTypes.PROFILE_PUT_DETAILS_FAIL:
      return putProfileDetailsFail(state, action);
    case actionTypes.PROFILE_SET_NEW_OBJ:
      return setNewProfileObj(state, action);

    default:
      return state;
  }
};

export default reducer;
